<template>
  <div>
    <v-row
      v-for="country in countries"
      :key="country.id"
      align="center"
      class="list--bordered py-1"
      no-gutters
    >
      <v-col
        class="shrink pr-2"
      >
        <v-icon
          color="red"
          @click="removeSelectedCountry(country.id)"
        >
          close
        </v-icon>
      </v-col>
      <v-col
        class="subtitle-1 grow"
      >
        {{ country.name }}
      </v-col>
      <v-col
        v-if="$can('set-income-costs', 'YachtModel')"
        cols="3"
        class="pr-2"
      >
        <currency-input
          v-model="country.pivot.projected_chartered_weeks"
          :precision="1"
          label="Projected weeks"
          hide-details
          outlined
          class="pa-0"
          @input="calculateYearlyIncome(country)"
        />
      </v-col>
      <v-col
        v-if="$can('set-income-costs', 'YachtModel')"
        cols="4"
        class="pr-2"
      >
        <currency-input
          v-model="country.pivot.average_weekly_price"
          :suffix="currency"
          :precision="0"
          label="Average weekly"
          hide-details
          outlined
          class="pa-0"
          @input="calculateYearlyIncome(country)"
        />
      </v-col>
      <v-col
        v-if="$can('set-income-costs', 'YachtModel')"
        cols="4"
      >
        <validation-provider
          v-slot="{ errors }"
          rules="required"
        >
          <currency-input
            v-model="country.pivot.yearly_income"
            :suffix="currency"
            :precision="0"
            label="Projected Yearly Income"
            hide-details
            outlined
            :error-messages="errors"
            class="pa-0"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CurrencyInput from '@/components/helpers/CurrencyInput'

export default {
    name: 'YachtModelCountryList',
    components: {
      CurrencyInput
    },
    props: {
      countries: {
        type: Array,
        default: () => []
      },
      currency: {
        type: String,
        default: 'EUR'
      }
    },
    methods: {
      removeSelectedCountry(countryId) {
        this.$emit('remove:country', countryId)
      },
      calculateYearlyIncome(country) {
        const weeks = parseFloat(country.pivot.projected_chartered_weeks) || 0
        const weeklyPrice = parseFloat(country.pivot.average_weekly_price) || 0
        if (weeks > 0 && weeklyPrice > 0) {
          country.pivot.yearly_income = Math.round(weeks * weeklyPrice)
        }
      }
    }
  }
</script>

<style scoped>

</style>
